/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormControllerContext from './FormControllerContext';

const FormController = ({
  children,
  disabled,
  error,
  required,
  fieldset,
  fullWidth,
  styles,
  status
}) => {

  const Tag = fieldset ? 'fieldset' : 'div';

  const classes = classNames('sui-inline-flex sui-flex-col sui-relative sui-min-w-0 sui-p-0 sui-m-0 sui-align-top', {
    'sui-w-full': fullWidth
  });

  return (
    <FormControllerContext.Provider
      value={{
        error,
        required,
        styles,
        status,
        disabled,
        fullWidth
      }}
    >
      <Tag className={classes}>
        {children}
      </Tag>
    </FormControllerContext.Provider>
  );
};

FormController.displayName = 'FormController';

FormController.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  fieldset: PropTypes.bool,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  styles: PropTypes.string,
  status: PropTypes.oneOf(['error', 'success', 'warning']),
};

export { FormController };
